<template>
    <section class="section-hero section-shaped my-0" style="z-index:1;">
        <div class="shape shape-style-1 shape-primary" style="
                background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(img/theme/main1.png);
                background-size: cover;
                background-position-x: center;">
            <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center pt-lg">
                        <img src="img/brand/logo-white.png" style="width: 200px;" class="img-fluid">
                        <p class="lead text-white mt-4 mb-5">
                            당신의 첫 번째 편안한 생활을 위한 공사
                        </p>
                    </div>
                </div>
                <div class="row align-items-center justify-content-around stars-and-coded">
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
